/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   useSavedCustomMessageToggle.ts
 */

import { event, toTraktorEventName } from '@zcode-ui/web-zumper-integrations'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS,
  SAVED_CUSTOM_MESSAGE_TRAKTOR_CATEGORY,
} from '../constants'
import { resetState, setCustomMessageChecked } from '../module/actions'
import { selectCustomMessageHasBeenChecked } from '../module/selectors'

export const useSavedCustomMessageToggle = (inputDirty: boolean, inputEmpty: boolean) => {
  const [hasTracked, setHasTracked] = useState(false)
  const dispatch = useDispatch()
  const customMessageHasBeenChecked = useSelector(selectCustomMessageHasBeenChecked)

  useEffect(() => {
    if (inputDirty && !inputEmpty && !hasTracked) {
      dispatch(
        event({
          name: toTraktorEventName(SAVED_CUSTOM_MESSAGE_TRAKTOR_CATEGORY),
          // @ts-expect-error props should be an object, not a string
          props: SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS.EDIT_MESSAGE,
        })
      )
      setHasTracked(true)
    }
    if (!customMessageHasBeenChecked && inputDirty && !inputEmpty) {
      dispatch(setCustomMessageChecked(true))
    }
    if (inputEmpty && customMessageHasBeenChecked) {
      dispatch(resetState())
    }
  }, [dispatch, hasTracked, inputDirty, inputEmpty, customMessageHasBeenChecked])
}
